﻿import React, { useState, useEffect } from 'react';
import { TextSymbolEditorData } from '../models/text-symbol-editor-data';

import { TextBox } from 'devextreme-react/text-box';
import { Button } from 'devextreme-react/button';

export interface Props {
    textInput?: string;
    propName?: string;
    onTextValueChanged?: (e: TextSymbolEditorData) => void;
    onApply?: (e: TextSymbolEditorData) => void;
    onCancel?: () => void;
}

export default function TextSymbolEditor(props: Props) {
    const [text, setText] =
        useState<string>(props.textInput ? props.textInput : undefined);


    /*
    state: Props;
    propName: string;

    constructor(props: Props) {
        super(props);

        this.applyClick = this.applyClick.bind(this);
        this.cancelClick = this.cancelClick.bind(this);
        this.symbolButtonClick = this.symbolButtonClick.bind(this);
        this.txtInputChange = this.txtInputChange.bind(this);
        this.insertSymbol = this.insertSymbol.bind(this);
        this.changeFontPosition = this.changeFontPosition.bind(this);

        this.state = {
            text: this.props.text
        };

        this.propName = this.props.propName ? this.props.propName : '';
    }

    render() {
    */

    return (
        <div>
            <div className="symbol-editor-container">
                <div className="symbol-editor-text-row">
                    <div className="symbol-editor">
                        <div className="pw-form-unit-label">Text</div>
                        <TextBox id="txtInput" value={text}
                            onValueChanged={txtInputChange} />
                    </div>

                    <Button id="subscript" icon="subscript"
                        className="symbol-button symbol-subscript-button"
                        onClick={symbolButtonClick} />
                    <Button id="superscript" icon="superscript"
                        className="symbol-button symbol-subscript-button"
                        onClick={symbolButtonClick} />
                    <Button id="normal" icon="fontsize"
                        className="symbol-button symbol-subscript-button"
                        onClick={symbolButtonClick} />
                </div>
            </div>

            <div>
                <div className="pw-form-unit-label">Common Symbols</div>
                <div className="symbol-editor-button-row">
                    <Button id="micro" text="µ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="degree" text="°"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="dot" text="·"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="c" text="©"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="r" text="®"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="tm" text="™"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="angstrom" text="Å"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                </div>
            </div>

            <div>
                <div className="pw-form-unit-label">Mathematics</div>
                <div className="symbol-editor-button-row">
                    <Button id="plusminus" text="±"
                        hint="plus/minus"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="multiply" text="×"
                        hint="multiply"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="squareroot" text="√"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="notequal" text="≠"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lessthanorequal" text="≤"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="greaterthanorequal" text="≥"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="infinity" text="∞"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="prime" text="ʹ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="doubleprime" text="ʺ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="arrowleft" text="←"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="arrowup" text="↑"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="arrowright" text="→"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="arrowdown" text="↓"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                </div>
            </div>

            <div>
                <div className="pw-form-unit-label">Greek Alphabet</div>
                <div className="symbol-editor-button-row">
                    <Button id="lalpha" text="α"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lbeta" text="β"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lgamma" text="γ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="ldelta" text="δ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lepsilon" text="ε"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lzeta" text="ζ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="leta" text="η"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="ltheta" text="θ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="liota" text="ι"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lkappa" text="κ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="llambda" text="λ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lmu" text="μ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lnu" text="ν"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lxi" text="ξ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lomicron" text="ο"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lpi" text="π"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lrho" text="ρ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lsigmamedian" text="σ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lsigmafinal" text="ς"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="ltau" text="τ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lupsilon" text="υ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lphi" text="φ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lchi" text="χ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lpsi" text="ψ"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                    <Button id="lomega" text="ω"
                        className="symbol-button"
                        onClick={symbolButtonClick} />
                </div>
                <div>
                    <div className="symbol-editor-button-row">
                        <Button id="ualpha" text="Α"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="ubeta" text="Β"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="ugamma" text="Γ"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="udelta" text="Δ"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="lepsilon" text="Ε"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="lzeta" text="Ζ"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="ueta" text="Η"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="utheta" text="Θ"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="uiota" text="Ι"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="ukappa" text="Κ"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="ulambda" text="Λ"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="umu" text="Μ"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="unu" text="Ν"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="uxi" text="Ξ"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="uomicron" text="Ο"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="upi" text="Π"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="urho" text="Ρ"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="usigma" text="Σ"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="utau" text="Τ"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="uupsilon" text="Υ"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="uphi" text="Φ"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="uchi" text="Χ"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="upsi" text="Ψ"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                        <Button id="uomega" text="Ω"
                            className="symbol-button"
                            onClick={symbolButtonClick} />
                    </div>
                </div>
            </div>

            <div className="symbol-editor-bottom-row">
                <Button id="symbol-editor-apply-button" text="Apply" type="success"
                    className="pw-button"
                    onClick={applyClick} />
                <Button id="symbol-editor-cancel-button" text="Cancel" type="success"
                    className="pw-button"
                    onClick={cancelClick} />
            </div>
        </div>
    );


    function symbolButtonClick(e: any) {
        //console.log("symbolButtonClick:");
        //console.log(e);

        if (e.element && e.element.id) {
            let symbolChar = e.element.innerText;

            switch (e.element.id) {
                case "subscript":
                    changeFontPosition("subscript");
                    break;
                case "superscript":
                    changeFontPosition("superscript");
                    break;
                case "normal":
                    changeFontPosition("normal");
                    break;
                default:
                    insertSymbol(symbolChar);
                    break;
            }
        }
    }

    function changeFontPosition(position: string) {
        let currentText = text;
        let textBox = document.getElementById('txtInput') as HTMLInputElement;

        if (currentText && textBox) {
            let textInput = document.querySelector("div[id='txtInput'] input") as HTMLInputElement;

            if (textInput) {
                let startPos = textInput.selectionStart;

                /*
                console.log(textInput.selectionStart);
                console.log(textInput.selectionEnd);
                */

                if (startPos && startPos >= 0 &&
                    textInput.selectionEnd && textInput.selectionEnd >= 1) {

                    let newString = "";

                    if (position === "subscript") {
                        newString = convertNumberToUnicodeSubscript(
                            currentText.substring(startPos, textInput.selectionEnd)
                        );
                    }
                    else if (position === "superscript") {
                        newString = convertNumberToUnicodeSuperscript(
                            currentText.substring(startPos, textInput.selectionEnd)
                        );
                    }
                    else {
                        newString = convertNumberToNormal(
                            currentText.substring(startPos, textInput.selectionEnd)
                        );
                    }

                    let newText = currentText.substring(
                        0, startPos) + newString + (currentText.substring(startPos +
                            (textInput.selectionEnd - startPos)));

                    let data: TextSymbolEditorData = {
                        propName: props.propName,
                        text: newText
                    };

                    if (props.onTextValueChanged)
                        props.onTextValueChanged(data);

                    setText(newText);
                    //this.setState({ text: newText });

                    setCaretPosition(textInput, startPos + newString.length)
                }
            }
        }
    }

    function convertNumberToNormal(value: string) {
        let newString = "";

        for (var i = 0; i < value.length; i++) {
            let letter = value.charCodeAt(i);

            //superscripted numbers 4-9 or 0
            if ((letter > 8307 && letter < 8314) || letter === 8304) {
                let charCode = letter - 8256;
                newString += String.fromCharCode(charCode);
            }
            else if (letter === 185) {
                let charCode = 49;
                newString += String.fromCharCode(charCode);
            }
            else if (letter === 178) {
                let charCode = 50;
                newString += String.fromCharCode(charCode);
            }
            else if (letter === 179) {
                let charCode = 51;
                newString += String.fromCharCode(charCode);
            }
            //subscripted letter
            else if (letter > 8319 && letter < 8330) {
                let charCode = letter - 8272;
                newString += String.fromCharCode(charCode);
            }
            else
                newString += String.fromCharCode(letter);
        }

        return newString;
    }

    function convertNumberToUnicodeSubscript(value: string) {
        let newString = "";

        for (var i = 0; i < value.length; i++) {
            let letter = value.charCodeAt(i);

            //normal numbers
            if (letter > 47 && letter < 58) {
                let charCode = 8320 + (letter - 48);
                newString += String.fromCharCode(charCode);
            }
            //superscripted numbers 4-9 or 0
            else if ((letter > 8307 && letter < 8314) || letter === 8304) {
                let charCode = letter + 16;
                newString += String.fromCharCode(charCode);
            }
            else if (letter === 185) {
                let charCode = 8321;
                newString += String.fromCharCode(charCode);
            }
            else if (letter === 178) {
                let charCode = 8322;
                newString += String.fromCharCode(charCode);
            }
            else if (letter === 179) {
                let charCode = 8323;
                newString += String.fromCharCode(charCode);
            }
            else
                newString += String.fromCharCode(letter);
        }

        return newString;
    }

    function convertNumberToUnicodeSuperscript(value: string) {
        let newString = "";

        for (var i = 0; i < value.length; i++) {
            let letter = value.charCodeAt(i);

            if (letter === 48 || (letter > 51 && letter < 58)) {
                let charCode = 8304 + (letter - 48);
                newString += String.fromCharCode(charCode);
            }
            else if (letter === 49) {
                newString += String.fromCharCode(185);
            }
            else if (letter === 50) {
                newString += String.fromCharCode(178);
            }
            else if (letter === 51) {
                newString += String.fromCharCode(179);
            }
            //subscripted letter
            else if (letter > 8319 && letter < 8330) {
                if ((letter > 8323 && letter < 8330) || letter === 8320) {
                    let charCode = letter - 16;
                    newString += String.fromCharCode(charCode);
                }
                else if (letter === 8321) {
                    let charCode = 185;
                    newString += String.fromCharCode(charCode);
                }
                else if (letter === 8322) {
                    let charCode = 178;
                    newString += String.fromCharCode(charCode);
                }
                else if (letter === 8323) {
                    let charCode = 179;
                    newString += String.fromCharCode(charCode);
                }
            }
            else
                newString += String.fromCharCode(letter);
        }

        return newString;
    }

    function insertSymbol(symbolChar: string) {
        let currentText = text;

        if (symbolChar) {
            let textBox = document.getElementById('txtInput') as HTMLInputElement;

            if (textBox) {
                //console.log(textBox);

                let textInput = document.querySelector("div[id='txtInput'] input") as HTMLInputElement;

                if (textInput) {
                    let startPos = textInput.selectionStart;

                    /*
                    console.log("selectionStart:");
                    console.log(startPos);
                    console.log(`text: ${currentText}`);
                    */

                    let newText = "";

                    if (startPos === 0) {
                        newText = symbolChar + currentText;
                    }
                    else {
                        if (currentText) {
                            if (startPos === currentText.length)
                                newText = currentText + symbolChar;

                            else if (startPos &&
                                startPos < currentText.length) {
                                newText = currentText.substring(
                                    0, startPos) + symbolChar + (currentText.substring(startPos));
                            }
                        }
                    }

                    //this.setState({ text: newText });

                    setText(newText);

                    if (startPos)
                        setCaretPosition(textInput, startPos + 1);
                }
            }
        }
    }

    function setCaretPosition(elem: any, caretPos: number) {
        try {
            if (elem != null) {
                if (elem.createRange) {
                    var range = elem.createRange();
                    range.move('character', caretPos);
                    range.select();
                }
                else {
                    if (elem.selectionStart) {
                        elem.focus();
                        elem.setSelectionRange(caretPos, caretPos);
                    }
                    else
                        elem.focus();
                }
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    function applyClick() {
        if (text) {
            let data: TextSymbolEditorData = {
                text: text,
                propName: props.propName
            };

            if (props.onApply)
                props.onApply(data);
        }
        else {
            if (props.onCancel)
                props.onCancel();
        }
    }

    function cancelClick() {
        if (props.onCancel)
            props.onCancel();
    }

    function txtInputChange(e: any) {
        //this.setState({ text: e.value });
        setText(e.value);
    }
}

